export type HamletPricingTier = {
  readonly unitStart: number;
  readonly unitLimit: number;
  readonly unitBlockSize: number;
  readonly price: number;
  readonly editionType: string;

  readonly editionTypeIsDeprecated: boolean;
  readonly renewalAmount: number;
  readonly unitLabel: string;
};
